import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'sopo-loader-dots',
    templateUrl: './sopo-loader-dots.component.html',
    styleUrls: ['./sopo-loader-dots.component.scss'],
    standalone: false
})
export class SopoLoaderDotsComponent implements OnInit {
    @Input() type: 'one' | 'two' = 'one';
    constructor() { }

    ngOnInit() { }

}
